module.exports = __webpack_public_path__ + "img/journey2.8524f108.jpg";